// extracted by mini-css-extract-plugin
export default {"main":"EventDetailsCard_main__bxtXZ","name":"EventDetailsCard_name__L-Zbu","value":"EventDetailsCard_value__j-h-O"};